export default __webpack_public_path__ + "static/media/watch.899c8855.png";